import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { catalogueApi } from '../services/api';
import { CatalogueShell, Spinner } from '../components/catalogue/CatalogueShell';
import { ProductGrid } from '../components/catalogue/ProductCard';

export default function FamilyPage() {
  const { brandId, familySlug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setData(null);
    catalogueApi.family(brandId, familySlug).then((r) => setData(r.data)).catch(() => setError(true));
  }, [brandId, familySlug]);

  const types = data ? [...new Set(data.products.map((p) => p.productType))] : [];

  return (
    <CatalogueShell
      brandId={brandId}
      crumbs={[{ label: 'Families', to: `/brand/${brandId}/families` }, { label: data?.name || familySlug }]}
      title={data?.name}
      intro={data ? `${data.products.length} versions · ${types.join(', ')}` : ''}
      testId="family-page"
    >
      {error ? <p className="text-gray-500" data-testid="family-not-found">Family not found.</p> : data ? (
        <ProductGrid brandId={brandId} products={data.products} />
      ) : <Spinner />}
    </CatalogueShell>
  );
}
